/* MYOP scroll-reveal — adds .myop-in to .myop-reveal elements as they enter
   the viewport. Respects prefers-reduced-motion (reveals immediately). */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revealNow(els) { els.forEach(function (el) { el.classList.add('myop-in'); }); }

  function init(scope) {
    var els = (scope || document).querySelectorAll('.myop-reveal:not(.myop-in)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) { revealNow(Array.prototype.slice.call(els)); return; }

    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          var delay = el.dataset.revealDelay;
          if (delay) el.style.transitionDelay = delay + 'ms';
          el.classList.add('myop-in');
          obs.unobserve(el);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });

    els.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  window.MyopAnimations = { init: init };
})();
